/**
 * Production-ready API configuration
 * Priority:
 * 1. REACT_APP_API_URL env variable (Netlify/Render production)
 * 2. Auto-detect ONLY for numeric LAN IP addresses (WiFi access)
 * 3. Fallback to localhost (local development)
 */

// Returns true only for numeric IP addresses like 192.168.1.5
// Will return false for public domains like shreyashotel.netlify.app
function isIpAddress(hostname) {
  return /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname);
}

export function getApiUrl() {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;

    // 1. If running on localhost or 127.0.0.1, prioritize localhost backend
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return `${protocol}//${hostname}:5000`;
    }

    // 2. If running on a numeric LAN/Wi-Fi IP, prioritize that IP
    if (isIpAddress(hostname)) {
      return `${protocol}//${hostname}:5000`;
    }
  }

  // 3. Fallback to explicit env variable (Netlify / Render production)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 4. Ultimate fallback
  return 'http://localhost:5000';
}

export async function getApiUrlWithDetection() {
  return getApiUrl();
}

export const API_URL = getApiUrl();
export default API_URL;
